import getAppStoreBadge from '../helpers/getAppStoreBadge'
import getGooglePlayBadge from '../helpers/getGooglePlayBadge'

export default function GooglePlayAndAppStoreBadgeLinks({
  preferAndroidFirst = false,
}: {
  preferAndroidFirst?: boolean
} = {}) {
  const appName = import.meta.env.VITE_APP_NAME as string
  const appleAppStoreUrl = import.meta.env.VITE_APP_URL_APPLE_APP_STORE as
    | string
    | undefined
  const googlePlayStoreUrl = import.meta.env.VITE_APP_URL_GOOGLE_PLAY_STORE as
    | string
    | undefined

  const androidBadge = googlePlayStoreUrl
    ? {
        alt: `Get ${appName} on Google Play`,
        src: getGooglePlayBadge(),
        url: googlePlayStoreUrl,
      }
    : null
  const iosBadge = appleAppStoreUrl
    ? {
        alt: `Download ${appName} on the App Store`,
        src: getAppStoreBadge(),
        url: appleAppStoreUrl,
      }
    : null

  const badges = (
    preferAndroidFirst ? [androidBadge, iosBadge] : [iosBadge, androidBadge]
  ).filter((badge) => badge !== null)

  if (badges.length === 0) {
    return null
  }

  return (
    <div className="flex flex-wrap items-center justify-center gap-4">
      {badges.map(({ alt, src, url }) => (
        <a
          className="transition-opacity hover:opacity-80"
          href={url}
          key={url}
          rel="noopener noreferrer"
          target="_blank"
        >
          <img alt={alt} className="h-12" src={src} />
        </a>
      ))}
    </div>
  )
}
